export default __webpack_public_path__ + "static/logo1-9f7722086ff6498a15f5a2693f50d215.svg";